"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenu = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const unstyled_list_1 = require("../lists/unstyled-list");
exports.DropdownMenu = (0, styled_components_1.default)(unstyled_list_1.BareUl) `
  position: absolute;
  display: block;
  left: 0;
  top: 100%;

  background: linear-gradient(to bottom, #eef0ec, #fcfcfc 80%);

  box-shadow: 5px 5px 5px #000;

  font-size: 14px;

  padding: 3px 0;

  li {
    white-space: nowrap;
    padding: ${props => props.withIcon ? "2.5px 25px 2.5px 2.5px" : "2.5px 25px"};

    font-weight: 100;
    color: black;

    &:hover {
      cursor: pointer;
      background: linear-gradient(to top, rgb(84, 192, 242), rgb(0, 168, 235));
      color: white;
    }
  }
`;
//# sourceMappingURL=dropdown-menu.js.map